'use client'

import { AdBannerScheduleType } from '@/app/types/adType'
import {
  setEventPageNo,
  setEventSortSelectedOption,
  setEventOrder,
  setAddOrRemoveMonth,
} from '@/app/globalRedux/filter/eventFilter'
import EventFilter from '../../search/(Filters)/EventFilter /EventFilter'
import EventList from './EventList'
import CustomErrorBoundary from '@/app/[lng]/ErrorBoundary'
import { useTranslation } from '@/app/i18n/client'
import SearchResults from '../../search/SearchResults'
import { openModal } from '@/lib/filterMobileModalHandler'
import SearchResultSort from '@/components/SearchResultSelect'
import Image from 'next/image'
import Tag from '@/components/ui/Tag'
import { RootState } from '@/app/globalRedux/store'
import { usePathname, useParams } from 'next/navigation'
import { useGetAdsQuery } from '@/app/globalRedux/api/adsSlice'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  addOrRemoveEventLocation,
  addOrRemoveEventLocationContinents,
} from '@/app/globalRedux/filter/eventFilter'

export const EventPage = () => {
  const pathName = usePathname()
  const params = useParams<{ lng: string }>()
  const adTerm =
    pathName?.split('/').pop() == 'events'
      ? 'Events Listing'
      : 'Search Results Events'
  const { data: eventAds = [] } = useGetAdsQuery<{
    data: AdBannerScheduleType[]
    isLoading: boolean
    isError: boolean
    isFetching: boolean
  }>({ page: adTerm, lang: params.lng })

  return (
    <div className="flex flex-row gap-7 mobile:flex-col">
      <div className="mobile:hidden">
        <EventFilter />
      </div>
      <div className="w-[627px] mobile-width">
        <SearchResultContainer />
        <CustomErrorBoundary>
          <EventList adList={eventAds} />
        </CustomErrorBoundary>
      </div>
    </div>
  )
}

export default EventPage
/*filter modal */

export const SearchResultContainer = () => {
  const dispatch = useDispatch()
  const pathName = usePathname()

  const [isEventsPage, setIsEventsPage] = useState<boolean | null>(null)

  useEffect(() => {
    const url = window.location.href

    if (url.split('/').includes('events')) {
      setIsEventsPage(true)
    } else {
      setIsEventsPage(false)
    }
  }, [pathName])

  useEffect(() => {
    if (pathName.includes('events-tab') || pathName.includes('events')) {
      dispatch(setEventPageNo(1))
    }
  }, [])

  if (isEventsPage === null) {
    return null
  }
  return isEventsPage ? <EventsFilterContainer /> : <SearchResults />
}
const EventsFilterContainer = () => {
  const eventFilter = useSelector((state: RootState) => state.eventFilter)
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const combinedArray = [
    ...eventFilter?.eventLocationContinents,
    ...eventFilter?.eventLocation,
    ...(eventFilter?.month ? [eventFilter?.month] : []),
  ]

  const getDispatchFunction = (item: any) => {
    if (eventFilter?.month.includes(item)) {
      return (item: any) => dispatch(setAddOrRemoveMonth(item))
    } else if (eventFilter?.eventLocation.includes(item)) {
      return (item: any) => dispatch(addOrRemoveEventLocation(item))
    } else if (eventFilter?.eventLocationContinents.includes(item)) {
      return (item: any) => dispatch(addOrRemoveEventLocationContinents(item))
    }
  }
  return (
    <div className="mb-4">
      <div className="flex flex-row justify-center mb-[20px] items-center mobile:mb-[10px]">
        <div className="text-[16px] font-bold text-[#4a4a4a]">
          {t('Events')}
        </div>
        <div className="ml-auto mobile:block hidden">
          <Image
            onClick={() => openModal('event-modal')}
            loading="lazy"
            width={30}
            height={30}
            src="/assets/Icons/mobile-filter-icon.svg"
            alt="filter-icon"
            className="border-[#ddd] border-solid bg-[#F4F4F4] px-[5px] py-[5px] rounded"
          />
          <div
            id="event-modal"
            className="modal-hidden fixed top-0 left-0 z-50 w-full h-full flex items-center justify-center bg-gray-900 bg-opacity-50 overflow-y-hidden"
          >
            <div className="bg-white rounded-lg overflow-y-auto shadow-xl transform transition-all sm:max-w-lg sm:w-full mobile:max-h-[80vh] mobile-width mobile:py-[10px] mobile:px-[10px]">
              <EventFilter />
            </div>
          </div>
        </div>
        <div className="ml-auto mobile:hidden">
          <SearchResultSort
            options="eventSort"
            selectedOption={eventFilter?.selectedEventSortOption}
            sortByFunction={(value) =>
              dispatch(setEventSortSelectedOption(value))
            }
            order={eventFilter.order}
            orderByFunction={(value) => dispatch(setEventOrder(value))}
          />
        </div>
      </div>
      <div className="border-t-2 border-t-[#e6e6e6] border-solid ">
        <div className="flex flex-row gap-[2px] mt-5 mobile:flex-col mobile:gap-[10px] mobile:mt-[10px]">
          {combinedArray.length !== 0 && (
            <>
              <div className="flex flex-row mr-[5px] items-center">
                <p className="text-[#6f6f6f] text-sm font-medium">
                  {t('Filters Applied')}
                </p>
              </div>
              <div className="flex flex-row flex-wrap gap-2 w-full max-w-[500px] items-center">
                {combinedArray.slice(0, 2).map((item: any) => (
                  <Tag
                    key={item.id || item.name}
                    label={t(item.name || item)}
                    callBackFunction={() => {
                      const dispatchFn = getDispatchFunction(item)
                      if (dispatchFn) dispatchFn(item)
                    }}
                  />
                ))}
                {combinedArray.length > 2 && (
                  <div className="text-[#fff] text-sm font-medium text-orange">
                    <p>{`+${combinedArray.length - 2}`}</p>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
